// @ vendor
import React, { PureComponent } from 'react';
import { fromJS } from 'immutable';
import PropTypes from 'prop-types';

// @utilities
const {
    getCustomKitOptions,
    getTitleKitFromRow,
    anyDiffInSecuritySets,
    getTextPillButton
} = require('utilities/securityKit/securityKitHelper');
const { formatText } = require('core/i18n').i18n;

// @constants
const { KITS: { KIT_CUSTOM } } = require('constants/securityKit');

// @components
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const OKPillSelectors = require('components/commons/OKPillSelectors/OKPillSelectors');
import InfoRow from 'components/myProfile/myProfileSecurityKitChange/infoRow/infoRow';


class ChangeSecurityKitStep extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            defaultKit: props.defaultKit,
            referencePillButton: props.referencePillButton,
            referenceKits: props.referenceKits,
            sets: props.sets,
            oldSets: props.sets
        };
        this.handlePillClick = this.handlePillClick.bind(this);
    }

    getPillActive(sets, defaultKit) {
      let defaultKitOutput = defaultKit
      const anyHaveAmounts = sets.some(function (set) {
          const amounts = set.get('amounts')
          if(!amounts) return false
          const amount = amounts.get('0')
          if(!amount) return false
          return (amount.get('value') !== undefined && amount.get('value') !== 0);
      });

      if (anyHaveAmounts) {
        defaultKitOutput = KIT_CUSTOM
      } else {
        const diff = sets.some(function (set) {
            return set.get('kitId') !== defaultKit
        });
        if (diff) defaultKitOutput = KIT_CUSTOM
      }

      return defaultKitOutput
    }

    handleAmountChange = (selected) => {
        const { setButtonDisabled } = this.props
        const amount = fromJS([{
            value: selected.value,
            targetKitId: selected.targetKitId
        }]);

        let currentIndexSet = this.state.sets.findIndex(set => {
            return set.get('id') === selected.idCart
        })

        let sets = null
        if (selected.value === 0) {
          sets = this.state.sets.update(currentIndexSet,
              set => {
                  return set.delete('amounts')
              }
          )
        } else {
          sets = this.state.sets.update(currentIndexSet,
              set => {
                  return set.set('amounts', amount)
              }
          )
        }

        const currentSet = sets.get(currentIndexSet)
        const defaultKit = this.getPillActive(sets, currentSet.get('kitId'))
        setButtonDisabled(anyDiffInSecuritySets(this.state.oldSets, sets))
        this.setState({
            sets,
            defaultKit: defaultKit,
        })
    }

    handleChangeCustomKit = (selected) => {
        const { sets, oldSets } = this.state
        const { setButtonDisabled } = this.props

        let output = sets.update(
            this.state.sets.findIndex(set => {
                return set.get('id') === selected.idCart
            }),
            set => {
                return set.merge({
                    amounts: (selected.value === set.get('kitId') ? set.get('amounts') : []),
                    kitId: selected.value
                })
            }
        )

        const defaultKit = this.getPillActive(output, selected.value)

        setButtonDisabled(anyDiffInSecuritySets(oldSets, output))

        this.setState({
            sets: output,
            defaultKit: defaultKit
        })
    }

    handlePillClick = (idPill) => {
      const { defaultKit, sets, oldSets } = this.state
      const { setButtonDisabled } = this.props
      if(idPill === defaultKit) return

      const setOutputs = sets.map((set) => {
        return set.merge({
            amounts: [],
            kitId: idPill
        })
      })

      setButtonDisabled(anyDiffInSecuritySets(oldSets, setOutputs))

      this.setState({
          defaultKit: idPill,
          sets: setOutputs
      })
    }

    renderSets = () => {
        const { sets, referenceKits} = this.state;
        const size = sets.size;
        if (sets && size) {
            return sets.map((set, i) => {
                const reference = set.get('referenceSet')
                const name = reference.get('name')
                const amountKit = [set.getIn(['amounts', 0, 'value'])]
                return (
                    <InfoRow
                        noBorder={size == i + 1}
                        key={i}
                        amount={amountKit}
                        onAmountChange={this.handleAmountChange}
                        selected={set.get('kitId')}
                        tilte={getTitleKitFromRow(name, referenceKits)}
                        onChange={this.handleChangeCustomKit}
                        options={getCustomKitOptions(set, referenceKits)}
                    />
                );
            });
        }

        return null;
    }

    buildPillSelectors() {
        const { defaultKit, referencePillButton, referenceKits } = this.state;
        const items = getTextPillButton(referencePillButton, referenceKits)

        return (
            <OKPillSelectors
                externalHandling={true}
                items={items}
                onSelectionChange={this.handlePillClick}
                selectedValues={[defaultKit]}
            />
        );
    }

    renderPills() {
        return (
            <div className="my-profile-security-kit-change__pills-container">
                <div className="my-profile-security-kit-change__title pull-left">
                    <div className="my-profile-security-kit-change__title-tooltip-container">
                        {formatText('securityKit-titleSectionChange')}
                    </div>
                    <OKTooltip
                        alternativeIcon={true}
                        content="securityKit-tooltipTitleOperative"
                        offset={[0, -15]}
                    />
                </div>
                <div className="my-profile-security-kit-change__pills-button-container">
                    {this.buildPillSelectors()}
                </div>
            </div>
        )
    }

    renderKits(){
      return (
          <div className="my-profile-security-kit-change__container-sets">
              {this.renderSets()}
          </div>
      )
    }

    render() {
      const customDesc = this.props.isNerudaUser ? 'securityKit-securityKit_customDescNerudaUser' : 'securityKit-customDesc';

      return (
          <div>
              <div className="my-profile-security-kit-change__title-container">
                  {formatText('securityKit-titleChangeView')}
              </div>
              { this.renderPills() }
              <div className="my-profile-security-kit-change__description-container">
                  {formatText(customDesc)}
              </div>
              { this.renderKits() }
          </div>
      )
    }
}

ChangeSecurityKitStep.propTypes = {
    defaultKit: PropTypes.string.isRequired,
    isNerudaUser: PropTypes.bool.isRequired,
    sets: PropTypes.object.isRequired,
    referenceKits: PropTypes.object.isRequired,
    referencePillButton: PropTypes.object.isRequired,
    setButtonDisabled: PropTypes.func.isRequired
};

export default ChangeSecurityKitStep;
